import React, { Component, PropTypes } from "react";
import { inject, observer } from 'mobx-react';
import { action, computed, observable, toJS } from "mobx";
import Form, { FormBody, DateInput, SelectInput, TextInput, FormActions, SwitchInput, RangeInput } from "../../Form";
import { analysis } from '../../../actions/api';
import _ from 'lodash';
import Spinner from '../../Spinner';
import RTable from './RTable2'
import RTGraph from "./RTGraph2";
import { findLineByLeastSquares, getByDate, deriveRatingEquation, roundOff, stageAddition } from "./helpers";
import { PARAMETER_ID } from "./config";
import moment from "moment";


@inject('stationStore')
@observer
export default class RTEquations extends Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };
  @observable filters = {
    station_id: 162,
    date_from: '2016-01-01', //moment().add(-7, 'days').format('YYYY-MM-DD'),
    date_to: '2017-01-01', //moment().format('YYYY-MM-DD'),

  };
  @observable dataParameters = [];
  @observable dataByDate = {};
  @observable loading = false;
  @observable useLog = false;
  @observable parameterOffsets = {
    a: 0, b: 0, offset: 0, optimumOffset: 0
  }
  @observable selectedPoint = { x: null, y: null };
  @observable stageRange = {
    from: 0,
    to: 50
  };

  @action onChangeFilter = (e, name) => {
    this.filters[name] = e.target.value;
    this.dataParameters = [];
    this.dataByDate = {};
  }

  @action onChangeStageRange = e => {
    this.stageRange = e.target.value;
    this.dataByDate = getByDate(this.dataParameters, this.stageRange);
  }

  showObservations = (e) => {
    const { notify } = this.context;
    e.preventDefault();

    const er = message => notify.error({ message });
    if (!this.filters.station_id) return er('Station filter required');
    if (!this.filters.date_from) return er('Start date filter required');
    if (!this.filters.date_to) return er('End date filter required');

    this.dataParameters = [];
    this.dataByDate = {};
    this.loading = true;
    analysis.fetchMore({
      stations: this.filters.station_id,
      parameters: Object.keys(PARAMETER_ID).map(key => PARAMETER_ID[key]).join(','),
      date_from: this.filters.date_from,
      date_to: this.filters.date_to
    }).then((data) => {
      if (!!data && !!data.length && !!data[0].parameters) {
        this.dataParameters = data[0].parameters;
        this.dataByDate = getByDate(data[0].parameters, this.stageRange);
        this.optimizeOffset();
        this.loading = false;
      } else {
        this.loading = false
        return er('No data in the stations with the given field of dates');
      }
    })
  }

  optimizeOffset = () => {
    let dataByDate = this.dataByDate;
    let h0 = 0, step = 0.01;
    let checkedDateKeys = Object.keys(dataByDate).filter(key => !!dataByDate[key].checked)
    if (!checkedDateKeys.length) return;

    let optimumOffset = null;
    while (true) {
      let observedDischarge = [];
      // eslint-disable-next-line
      checkedDateKeys.forEach(date => {
        let stage = stageAddition(dataByDate[date].WL_M, h0 * -1); // ((100 * dataByDate[date].WL_M) - (100 * h0)) / 100;
        observedDischarge.push([stage, dataByDate[date].Q_M])
        // observedDischarge.push([dataByDate[date].WL_M, dataByDate[date].Q_M])
      })
      let ratingEquation = deriveRatingEquation(observedDischarge, h0);
      if (!ratingEquation.parameters.a || !ratingEquation.parameters.b) {
        break;
      } else {
        if (!optimumOffset || optimumOffset.rmse > ratingEquation.parameters.rmse) {
          optimumOffset = {
            value: h0,
            rmse: ratingEquation.parameters.rmse
          }
        }
        h0 = stageAddition(h0, step);
      }
    }
    this.parameterOffsets.optimumOffset = roundOff(optimumOffset.value, 2);
    this.parameterOffsets.offset = roundOff(optimumOffset.value, 2);
  }

  getRatingCurveData = (dataByDate, parameterOffsets) => {
    if (!Object.keys(this.dataByDate).length) return null;

    let checkedDateKeys = Object.keys(toJS(dataByDate)).filter(key => !!dataByDate[key].checked);
    if (!checkedDateKeys.length) return null;

    let h0 = parameterOffsets.offset;
    let observedDischarge = [];
    checkedDateKeys.forEach(date => {
      let stage = stageAddition(dataByDate[date].WL_M, h0 * -1); // ((100 * dataByDate[date].WL_M) - (100 * h0)) / 100;
      observedDischarge.push([stage, dataByDate[date].Q_M])
      // observedDischarge.push([dataByDate[date].WL_M, dataByDate[date].Q_M])
    })
    observedDischarge.sort((a, b) => a[1] - b[1]);
    let ratingEquation = deriveRatingEquation(observedDischarge, h0);
    return {
      observedDischarge: {
        normalSeries: observedDischarge,
        logSeries: observedDischarge.map(item => ([Math.log(item[0]), Math.log(item[1])]))
      },
      ratingEquation
    };
  }

  render() {
    const { stationStore } = this.props;
    const ratingCurveData = this.getRatingCurveData(this.dataByDate, this.parameterOffsets);
    // console.log(toJS(this.dataByDate))

    return <div className='flex flex-row'>
      <div style={{ flexGrow: 1 }}>
        <Form>
          <FormBody>
            <SelectInput label={'Station'} value={this.filters.station_id} fields={{ label: 'name', value: 'id' }} options={stationStore.items} onChange={e => this.onChangeFilter(e, 'station_id')} isLoading={stationStore.isLoading} />
            <DateInput label={'Date From'} value={this.filters.date_from} onChange={e => this.onChangeFilter(e, 'date_from')} />
            <DateInput label={'Date To'} value={this.filters.date_to} onChange={e => this.onChangeFilter(e, 'date_to')} />
            <RangeInput label={'Stage Range'} value={this.stageRange} onChange={this.onChangeStageRange} min={0} step={0.1} />
            <SwitchInput label={'Log Scale'} value={this.useLog} onChange={() => this.useLog = !this.useLog} />
          </FormBody>
          <FormActions >
            <button onClick={this.showObservations}>View</button>
          </FormActions >
        </Form>
        {this.loading && <Spinner />}
        {!!ratingCurveData && <RTGraph ratingCurveData={ratingCurveData} useLog={this.useLog} onMouseOver={(x, y) => { this.selectedPoint.x = x; this.selectedPoint.y = y; }} />}
      </div>
      <div style={{ flexGrow: 1 }}>
        {!!Object.keys(this.dataByDate).length && <RTable dataByDate={this.dataByDate} parameters={_.get(ratingCurveData, 'ratingEquation.parameters', {})} parameterOffsets={this.parameterOffsets} useLog={this.useLog} selectedPoint={this.selectedPoint} optimizeOffset={this.optimizeOffset} />}
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/RTEquationsDerive.js